import styled from "styled-components"

export const Button = styled.button`
  position: absolute;
  top: 96px;
  left: 50%;
  transform: translateX(-50%);
  border: 0;
  border-radius: 20px;
  padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  color: ${({ theme }) => theme.colors.gray[900]};
  box-shadow: ${({ theme }) => theme.boxShadow};
  z-index: 1000;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing * 2}px;
  height: 40px;
  box-sizing: border-box;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    top: 16px;
  }
  > svg {
    width: 24px;
    height: 24px;
  }
`;
